import http from "@/settings/apiSettings"

class ProduseDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/PRO_Produse", data);
    }
    update(key: string, data: any): Promise<any> {
        return http.clientComercialOdata.patch(`/PRO_Produse(${key})`, data);
    }
    getParents(): Promise<any> {
        return http.clientComercialOdata.get("/PRO_Clase/with-parent");
    }

}
export default new ProduseDataService();